import { LockOutlined, RocketOutlined } from '@ant-design/icons';
import { Card } from 'antd';
import { Link } from 'react-router-dom';
import { ReactNode } from 'react';
import { PageInfoCard } from '../PageInfoCard';
import { useModuleActive } from './Roles';

type ModuleAccessGateProps = {
	module: string;
	title: string;
	pageInfo?: string;
	message?: string;
	showPlanButton?: boolean;
	/** Solo la caja de bloqueo, sin Card/título (p. ej. dentro de un tab) */
	embedded?: boolean;
	children: ReactNode;
};

export const ModuleLockedBox = ({
	pageInfo,
	message = 'No tienes permisos para acceder a esta funcionalidad con tu plan actual.',
	showPlanButton = true,
}: {
	pageInfo?: string;
	message?: string;
	showPlanButton?: boolean;
}) => (
	<div style={{ padding: '28px 16px', display: 'flex', justifyContent: 'center' }}>
		<div
			style={{
				maxWidth: 640,
				width: '100%',
				borderRadius: 12,
				border: '1px solid #f5a3a8',
				background: '#fff',
				boxShadow: '0 2px 10px rgba(207, 19, 34, 0.08)',
				padding: '28px 28px 24px',
				textAlign: 'center',
			}}
		>
			<div
				style={{
					width: 52,
					height: 52,
					borderRadius: '50%',
					background: '#fff2f0',
					border: '1px solid #f5a3a8',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					margin: '0 auto 14px',
				}}
			>
				<LockOutlined style={{ fontSize: 22, color: '#ff4d4f' }} />
			</div>
			<div style={{ fontSize: 17, fontWeight: 600, color: '#cf1322', marginBottom: 8 }}>
				Acceso restringido
			</div>
			<div style={{ fontSize: 14, color: '#a8071a', lineHeight: 1.5, marginBottom: pageInfo || showPlanButton ? 20 : 0 }}>
				{message}
			</div>

			{pageInfo && (
				<div style={{ marginBottom: showPlanButton ? 20 : 0 }}>
					<PageInfoCard description={pageInfo} />
				</div>
			)}

			{showPlanButton && (
				<Link to='/configurar/plan' style={{ color: '#1677ff', fontSize: 13 }}>
					<RocketOutlined style={{ marginRight: 6 }} />
					Ver plan de negocio
				</Link>
			)}
		</div>
	</div>
);

/**
 * Si el módulo no está activo, muestra título + card de bloqueo (con info integrada).
 * Si está activo, renderiza children.
 */
export const ModuleAccessGate = ({
	module,
	title,
	pageInfo,
	message,
	showPlanButton = true,
	embedded = false,
	children,
}: ModuleAccessGateProps) => {
	const isModuleActive = useModuleActive();

	if (isModuleActive(module)) {
		return <>{children}</>;
	}

	if (embedded) {
		return (
			<ModuleLockedBox
				pageInfo={pageInfo}
				message={message}
				showPlanButton={showPlanButton}
			/>
		);
	}

	return (
		<Card className='main-card-content'>
			<h1 className='title-card' style={{ marginBottom: 0 }}>{title}</h1>
			<ModuleLockedBox
				pageInfo={pageInfo}
				message={message}
				showPlanButton={showPlanButton}
			/>
		</Card>
	);
};
